<template>
  <div class="notification-manager">
    <!-- Модальні сповіщення -->
    <ModalNotificationComponent
      v-for="modalNotification in modalNotifications"
      :key="modalNotification.key"
      :notification="modalNotification"
      @dismissed="handleNotificationDismissed"
    />
    
    <!-- Toast сповіщення -->
    <div aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-end sm:p-6 z-500 bottom-0">
      <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
        <ToastNotificationComponent
          v-for="toastNotification in toastNotifications"
          :key="toastNotification.key"
          :notification="toastNotification"
          @dismissed="handleNotificationDismissed"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import ModalNotificationComponent from './ModalNotificationComponent.vue'
import ToastNotificationComponent from './ToastNotificationComponent.vue'

export default {
  name: 'NotificationManagerComponent',
  components: {
    ModalNotificationComponent,
    ToastNotificationComponent
  },
  setup() {
    const store = useStore()
    const dismissedNotifications = ref(new Set())

    // Отримуємо сповіщення зі стору
    const userNotifications = computed(() => {
      const user = store.getters['user/user']
      return user?.notifications || []
    })

    // Фільтруємо модальні сповіщення
    const modalNotifications = computed(() => {
      return userNotifications.value
        .filter(notification => 
          notification.type === 'modal' && 
          !dismissedNotifications.value.has(notification.key)
        )
    })

    // Фільтруємо toast сповіщення
    const toastNotifications = computed(() => {
      return userNotifications.value
        .filter(notification => 
          notification.type === 'toast' && 
          !dismissedNotifications.value.has(notification.key)
        )
    })

    const handleNotificationDismissed = (notificationKey) => {
      dismissedNotifications.value.add(notificationKey)
    }



    const isLoggedIn = computed(() => {
      return store.getters['user/isLoggedIn']
    })

    // Слідкуємо за змінами в сповіщеннях користувача
    watch(userNotifications, (newNotifications) => {
      // Очищаємо відхилені сповіщення, які більше не активні
      const activeKeys = new Set(newNotifications.map(n => n.key))
      const newDismissed = new Set()
      
      for (const key of dismissedNotifications.value) {
        if (activeKeys.has(key)) {
          newDismissed.add(key)
        }
      }
      
      dismissedNotifications.value = newDismissed
    }, { deep: true })

    return {
      modalNotifications,
      toastNotifications,
      handleNotificationDismissed,
      isLoggedIn
    }
  }
}
</script>




